import { Injectable } from '@angular/core';
import {
  Camera,
  CameraResultType,
  CameraSource,
  Photo,
} from '@capacitor/camera';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { Preferences } from '@capacitor/preferences';
import { StateService } from './state.service';

@Injectable({
  providedIn: 'root',
})
export class CameraService {
  constructor(private state: StateService) {}

  public async getPhoto(): Promise<any> {
    // Take a photo
    return await Camera.getPhoto({
      resultType: CameraResultType.Uri,
      source: CameraSource.Camera,
      quality: 100,
    });
  }

  /*public async getVideo(): Promise<any>{
    return await Camera.
  }*/
}
